import React from 'react';
import {
  Filter,
  List,
  Edit,
  Create,
  SimpleForm,
  Datagrid,
  TextField,
  TextInput,
  EditButton,
  Responsive,
  SimpleList,
  Show,
  SimpleShowLayout,
  LongTextInput
} from "react-admin";
import { Link } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';

export const EtapasFilter = props => {
  return (
    <Filter {...props}>
      <TextInput label="Nombre" source="searchnombre" alwaysOn autoFocus/>
    </Filter>
  )
}

const EtapaNameEdit = ({ record }) => {
  return (
    <Responsive
      small={<span>Editar Etapa</span>}
      medium={
        <span>Editar Etapa: {record ? `"${record.nombre}"` : ""}</span>
      }
    />
  );
};

const EtapaNameShow = ({ record }) => {
  return <span>Mostrando: {record ? `"${record.nombre}"` : ""}</span>;
};

export const EtapaShow = props => (
  <Show title={<EtapaNameShow />} {...props}>
    <SimpleShowLayout>
      <TextField label="Nombre de Etapa" source="nombre" />
    </SimpleShowLayout>
  </Show>
);

export const EtapaEdit = props => (
  <Edit title={<EtapaNameEdit />} {...props}>
    <SimpleForm>
      <TextInput label="Nombre de Etapa" source="nombre" />
      <LongTextInput label="Descripción" source="descripcion" />
    </SimpleForm>
  </Edit>
);

export const EtapaCreate = props => (
  <Create {...props} title="Incorporar Etapa">
    <SimpleForm redirect="/etapas">
      <TextInput label="Nombre de Etapa" source="nombre" />
      <LongTextInput label="Descripción" source="descripcion" />
    </SimpleForm>
  </Create>
);

export const EditableEtapaList = props => (
  <List {...props} bulkActions={false} filters={<EtapasFilter />} sort={{ field: "nombre", order: "ASC" }}>
    <Responsive
      small={
        <SimpleList
          primaryText={record =>
            record.nombre.replace(/\b\w/g, l => l.toUpperCase())
          }
          secondaryText={record => record.descripcion }

        />
      }
      medium={
        <Datagrid>
          <TextField style={{ textTransform: "capitalize" }} source="nombre" />
          <TextField source="descripcion" />
          <CreateEtapaButton history={props.history} />
          <EditButton />
        </Datagrid>
      }
    />
  </List>
);

export const EtapaList = props => (
  <List {...props} bulkActions={false} filters={<EtapasFilter />}>
    <Responsive
      small={
        <SimpleList
          primaryText={record => record.nombre}
          linkType="show"
        />
      }
      medium={
        <Datagrid>
          <TextField source="nombre" />
        </Datagrid>
      }
    />
  </List>
);

class CreateEtapaButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Link to="/etapas">
        <IconButton
          style={{fontWeight: 'regular', fontSize: '0.8125rem'}}
          aria-label="Crear Etapa" color="primary"
        >
        </IconButton>
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/etapas.js